import {
    getToken, setToken, removeToken
    , getReviewToken, setReviewToken
    , getWechatOpenId, setWechatOpenId
    , setPPPKey, getPPPKey, removePPPKey, setViewSource, getViewSource
}
    from '@/utilities/userToken'
import api from '@/api'

export default {
    state: ()=> ({
        userInfo: {},
        userToken: getToken(),
        userReviewToken: getReviewToken(),
        wechatOpenId: getWechatOpenId(),
        contacts: [],
        pppKey: getPPPKey(),
        bookingsCount: 0,
        wishListCount: 0,
        couponsCount: 0,
        viewSource: getViewSource()
    }),
    actions: {
        GET_USER_INFO: async ({ commit }, userToken) => {
            if (userToken && userToken.length > 0) {
                const { success, data, errMsg } = await api.user.getUserInfo()
                if (!success) console.error(errMsg)
                commit('SET_USER_INFO', { userInfo: data })
            }
        },
        SET_USER_TOKEN: ({ commit }, token) => {
            commit('SET_USER_TOKEN', { token })
        },
        GET_USER_CONTACTS: async ({ commit }, userToken) => {
            if (userToken && userToken.length > 0) {
                const { success, data, errMsg } = await api.user.getContact(userToken)
                if (!success) console.error(errMsg)
                commit('GET_USER_CONTACTS', data)
            }
        },
        SET_VIEW_SOURCE: ({ commit }, viewSource) => {
            commit('SET_VIEW_SOURCE', { viewSource })
        }
    },
    mutations: {
      SET_USER_TOKEN: (state, { token }) => {
          state.userToken = token
          setToken(token)
      },
      REMOVE_USER_TOKEN (state) {
          state.userToken = ''
          state.userInfo = {}
          removeToken()
          removePPPKey ()
      },
      SET_USER_INFO: (state, { userInfo }) => {
          if (userInfo) {
            state.userInfo = userInfo;
          } else {
              state.userInfo = {}
          }
      },
      SET_REWARD_TOKEN (state, rewardToken) {
          state.userReviewToken = rewardToken
          setReviewToken(rewardToken)
      },
      SET_WECHAT_OPENID (state, openId) {
          state.wechatOpenId = openId
          setWechatOpenId(openId)
      },
      GET_USER_CONTACTS (state, contacts) {
          state.contacts = contacts
      },
      SET_PERSONAL_CENTER_ITEM_COUNT (state, { bookingsCount, wishListCount, couponsCount }) {
          state.bookingsCount = bookingsCount
          state.wishListCount = wishListCount
          state.couponsCount = couponsCount
      },
      SET_PPP_KEY (state, pppKey) {
          state.pppKey = pppKey
          setPPPKey(pppKey)
      },
      REMOVE_PPP_KEY (state) {
            removePPPKey()
            state.pppKey = ""
      },
      SET_VIEW_SOURCE: (state, { viewSource }) => {
          state.viewSource = viewSource;
          setViewSource(viewSource)
      }
    }
  }
